import { render, staticRenderFns } from "./RatingStar.vue?vue&type=template&id=ab13508c&"
import script from "./RatingStar.vue?vue&type=script&lang=js&"
export * from "./RatingStar.vue?vue&type=script&lang=js&"
import style0 from "./RatingStar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports